import React from 'react';
import { ExcelTableCellProps } from '../../TableCell';
import { observer } from 'mobx-react';
import { WeaUpload } from 'ecCom';
import { getDomIdByFieldKey } from '../../../../util/typeUtil';
import { modeForm } from '../../../../util/excelUtil';
import { WeaLocaleProvider } from "ecCom";
const getLabel = WeaLocaleProvider.getLabel;

import jQuery from 'jquery';
import { toJS } from 'mobx';


@observer
export default class UploadElement extends React.Component<ExcelTableCellProps, any>{
    render() {
        const { cell, form, card, className, excel } = this.props;
        const fileisdisplay = card.base.fileisdisplay;
        const path = cell.getPath();
        const bindObj = form.$(path);
        const fieldName = getDomIdByFieldKey(bindObj.path);
        const { value, viewAttr: _viewAttr, isEdit, isMandatory, uploadData: { filedatas = [], showBatchLoad = false } = {} } = bindObj.bind();
        const { fieldid, fieldtype, isdetail, imgheight, imgwidth, fileFormat, categorytypeown } = card.getFieldProps(path);
        const docCategroy = card.docCategroy;
        let viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        const { base, empowmentType, quickEditStore,getDetailFormValues ,params} = card;
        const { billid, modeId } = base;
        if (excel.detailProps && excel.detailProps.hasOwnProperty("isEdit") && params.type == '2') {
            //如果明细表字段，设置了不可编辑已有明细,则已有明细不可编辑，但新增的明细可以编辑
            if (getDetailFormValues(form).dtl_id && !excel.detailProps["isEdit"]) {    //如果是新增加的行，不会产生dtl_id，已有明细才有该字段
                viewAttr = 1;
            }
        }
        let secretLevel = '';
        let seclevelInfo = card.seclevelInfo;
        const casProtect = card.seclevelInfo == 'field-9'; // 是否开启分级保护

        if( seclevelInfo !=undefined && seclevelInfo !="-1"){
            if( modeForm.getCurrentModeStore().cubeForm.$(seclevelInfo).values() !=''){
                secretLevel = modeForm.getCurrentModeStore().cubeForm.$(seclevelInfo).values();
            }
        }

        let main;
        let sub;
        let sec;
        let maxUploadSize;
        let mes;

        let category;

        //用户自定义
        if (categorytypeown === "0") {//固定目录
            const { maincategory, subcategory, seccategory, limitValue } = card.getFieldProps(path);
            main = maincategory;
            sub = subcategory;
            sec = seccategory;
            maxUploadSize = limitValue;
        } else if (categorytypeown === "1") {//选择目录
            const { selectFieldId } = card.getFieldProps(path);
            const category = card.chooseDocCategroy(selectFieldId);
            main = category.mainCategory;
            sub = category.subCategory;
            sec = category.secCategory;
            maxUploadSize = category.maxUploadSize;
            mes = category.msg;
        } else {
            main = docCategroy.mainCategory;
            sub = docCategroy.subCategory;
            sec = docCategroy.secCategory;
            maxUploadSize = docCategroy.maxUploadSize;
            mes = docCategroy.msg;
        }

        const flag = (parseInt(main, 0) != 0 && !isNaN(parseInt(main, 0)) && parseInt(main, 0) != -1)
            || (parseInt(sub, 0) != 0 && !isNaN(parseInt(sub, 0)) && parseInt(sub, 0) != -1)
            || (parseInt(sec, 0) != 0 && !isNaN(parseInt(sec, 0)) && parseInt(sec, 0) != -1);
        if (!flag && viewAttr != "1") {
            if (!mes) {
                mes = getLabel(83157, "附件上传目录未设置") + "!";
            }
            return <span style={{ color: '#ff0000' }} id={fieldName}>
                <div className={`fieldValue ${className}`} data-fieldattr={viewAttr} data-fieldmark={fieldName}>
                    <span style={{ position: "relative", display: "inline-block" }}>
                        {mes} {viewAttr == 3 && <span className="required"></span>}
                    </span>
                </div>
            </span>
        }
        category = main + "," + sub + "," + sec;

        let uploadUrl = "/api/formmode/card/docUpload?detailtype=" + fieldtype + "&category=" + category + "&mainId=" + main + "&subId=" + sub + "&secId=" + sec;
        const baseProps: any = {};
        baseProps.showBatchLoad = card.base.type != '1' && !isdetail ? showBatchLoad : false;
        // baseProps.showClearAll = !isdetail;
        baseProps.showClearAll = false;
        baseProps.uploadUrl = uploadUrl;
        baseProps.maxUploadSize = maxUploadSize;
        baseProps.category = category;
        if(base.type == '0'&& viewAttr != '1'){
            baseProps.datas = toJS(filedatas).map(item=>{
                return {...item,showDelete:true}
            });
        }else{
            baseProps.datas = filedatas.slice();
        }
        if (!value) {
            baseProps.datas = []; //清空value，也需将datas置空
            filedatas&&filedatas.length>0&&this.clearUploadData(); //清空value，需将uploadData置空
        }
        baseProps.btnSize = isdetail ? "small" : "default";
        baseProps.autoUpload = true;
        baseProps.listType = fieldtype == '2' ? "img" : "list";
        baseProps.limitType = fieldtype == "2" ? "jpg,jpeg,png,gif,bmp" : fileFormat === "0" ? "" : fileFormat;
        baseProps.uploadId = fieldName;
        // baseProps.errorMsg = mes;
        baseProps.display = true;
        if (fieldtype == '2') {
            baseProps.imgWidth = imgwidth + "px";
            baseProps.imgHeight = imgheight + "px";
            jQuery('.mode-upload-wrap .wea-upload .wea-upload-imgs-item').css("padding", '0 5px 0 0');
        }
        if (!isdetail) {
            let batchLoadUrl = `/weaver/weaver.file.FileDownload?fieldvalue=${value}&download=1&downloadBatch=1&desrequestid=0`;
            if (empowmentType == '0') {//开启临时赋权
                batchLoadUrl += `&formmode_authorize=formmode_authorize&moduleid=formmode&authorizemodeId=${modeId}&authorizefieldid=${fieldid}&authorizeformmodebillId=${billid}`;
            }
            baseProps.batchLoadUrl = batchLoadUrl;
        }
        let secParams = {}; // 分级保护相关参数，仅对附件上传生效
        if (fieldtype==='1') {
            secParams = {
                secLevel:secretLevel,
                secLevelInfo:getLabel('530630','请先填写卡片密级！'),
                showSecLevel:casProtect,
                casProtect:casProtect,
                // allowEditSec:(base.type=='1'||(base.type=='2'&&card.datastatus==1))?true:false,
                allowEditSec: false, // 关闭修改密级功能
                oneline:!casProtect
            }
        }
        let canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && isdetail && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
		let isDisplay = '';
		if(!canQuickedit){
			isDisplay = 'none';
		}
        return (
            <div className={`${fieldtype == '2' ? "cube-upload-img" : ""} ${canQuickedit ? 'cube-card-editformitem ' : 'cube-card-editformitem2'}  fieldValue ${className} mode-upload-wrap`}
                data-fieldattr={viewAttr}
                data-fieldmark={fieldName}
                {...cell.cellProps}
                onClick={() => { canQuickedit && quickEditStore.lockEditFormItem(fieldName); }}
            >
                <WeaUpload ecId={`${this && this.props && this.props.ecId || ''}_WeaUpload@af734b`}
                    {...baseProps}
                    {...bindObj.bind()}
                    onChange={this.doChangeEvent}
                    isDetail={isdetail}
                    fieldName={fieldName}
                    viewAttr={viewAttr}

                    showUploader={fileisdisplay == 1 ? true : false}
                    showUploadTime={fileisdisplay == 1 ? true : false}
                    onUploading={this.onUploading}
                    oneline={true}
                    editable={true}
                    showEditButton={false}
                    getShowListDatas={this.getShowListDatas}
                    {...secParams}
                />
                <span className="editicon" style={{display:isDisplay}}><i className="icon-coms-edit" ></i></span>
            </div>
        )
    }
    getShowListDatas = (listT, newList) => {
        const { cell, form } = this.props;
        const { field } = cell;
        let fieldid = `field${field}`;
        const bindObj = form.$(fieldid);
        if (bindObj.values() == '') {
            if (newList.length > 0) {
                bindObj.onChange('-1')
            }
        } else if (newList.length <= 0 && listT.length <= 0) {
            bindObj.onChange('')
        }
    }
    onUploading = (state) => {
        const { cell, form } = this.props;
        const path = cell.getPath();
        if (form.has(path)) {
            const bindObj = form.$(path);
            bindObj.setUploadState(state);
        }
    }
    /**
    * 附件上传回调方法
    */
    doChangeEvent = (idsT, filedatas, datas) => {
        const { cell, form } = this.props;
        const path = cell.getPath();
        let i = 0
        filedatas.map(item => {
            let { fileid } = item;
            let id = fileid;
            datas.map(items => {
                let { fileid, uploaddate, username } = items;
                let params = { "uploaddate": uploaddate, "username": username }
                if (id == fileid) {
                    filedatas[i] = { ...filedatas[i], ...params };
                }
            });
            i++;
        });
        if (form.has(path)) {
            const bindObj = form.$(path);
            bindObj.onChange(idsT.join(','));
            bindObj.setUploadData({
                filedatas,
                showBatchLoad: bindObj.uploadData.showBatchLoad
            })
        }
    }
    clearUploadData = () => {
        const { cell, form } = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        bindObj.setUploadData({
            filedatas: [],
            showBatchLoad: bindObj.uploadData.showBatchLoad
        })
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/upload-element/index.tsx